import { type AxiosInstance } from "axios";

/**
 * 一覧に表示した変動アラートをまとめて既読にする。
 * @param {AxiosInstance} apiClient JWT 認証付き apiClient
 * @param {number[]} ids アラート ID（1 回 100 件まで）
 */
export const MarkRegistryChangeAlertsReadAPI = async (
  apiClient: AxiosInstance,
  ids: number[]
): Promise<void> => {
  await apiClient.post("/registry-change-alerts/read", { ids });
};
